import { on } from "svelte/events";
import { hintSlotName, errorSlotName } from "../slotNames";
import { ensureId } from "./ensureId";

/**
 *
 *
 *
 *
 *
 */
const getSlotIds = (host: HTMLElement, slotName: string): string[] =>
  Array.from(host.querySelectorAll<HTMLElement>(`[slot="${slotName}"]`), ensureId);

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useHintAndValidationMessage = (
  Host: () => HTMLElement,
  actionElement: () => HTMLElement | undefined,
): void => {
  let hintIds = $state(getSlotIds(Host(), hintSlotName));
  let validationMessageIds = $state(getSlotIds(Host(), errorSlotName));

  /*                                                                                 */
  const ariaDescribedBy = $derived([...validationMessageIds, ...hintIds].join(" "));

  /*                                                                     */
  $effect(() =>
    on(
      Host().shadowRoot!,
      "slotchange",
      (ev) => {
        const slot = ev.composedPath()[0] as HTMLSlotElement;
        if (slot.name === hintSlotName) hintIds = getSlotIds(Host(), hintSlotName);
        if (slot.name === errorSlotName) validationMessageIds = getSlotIds(Host(), errorSlotName);
      },
      {
        passive: true,
      },
    ),
  );

  $effect(() => {
    const ele = actionElement();
    if (!ele) return;

    /*                                                                           */
    if (ariaDescribedBy.length === 0) {
      ele.removeAttribute("aria-describedby");
    } else {
      ele.setAttribute("aria-describedby", ariaDescribedBy);
    }

    /*                                                                          */
    ele.ariaInvalid = validationMessageIds.length > 0 ? "true" : null;
  });
};
